import React, { useState } from 'react';
import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import DashboardCard26otheredit from '../../partials/dashboard/DashboardCard26otheredit';

function EditOtheractivity() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto ">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full xs:pb-10 max-w-9xl mx-auto">
                        <div className="sm:flex sm:justify-between sm:items-center mb-8">
                            <div className="mb-4 sm:mb-0">
                                <h1 className="text-2xl md:text-3xl xs:pb-10 text-gray-800 dark:text-gray-100 font-bold">Editeaza Alte activitati</h1>
                            </div>
                        </div>
                        <div className='pb-14 sm:pb-0 md:pb-0 lg:pb-0'>
                            <DashboardCard26otheredit />
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}

export default EditOtheractivity;